import { useRouter } from 'next/router';
import { Separator } from '@global-ecom/nitro-uds/elements';

import { usePdp } from 'hooks/usePdp';
import { Sizes } from 'ui/components/Sizes';
import { useSiteConfig } from 'hooks/useSiteConfig';
import { usePageEventsContext } from 'hooks/usePageEventsContext';
import { AnalyticsEvents, event } from 'utils/analytics';

export const ProductSizePicker = ({
  inventory,
  isModalSizeOpen,
}: {
  inventory?: number;
  isModalSizeOpen?: boolean;
}) => {
  const router = useRouter();
  const {
    desiredSize,
    masterProduct,
    variation,
    addToCartReturnCode,
    isQueryStale,
    setSizeHasChanged,
  } = usePdp();

  const { staticFeatures } = useSiteConfig();
  const { useStockInfoRedesign } = staticFeatures;
  const { pageviewEventHasFired } = usePageEventsContext();

  if (!variation) return null;
  let sizesProps: any = {
    sizeGroups: variation.sizeGroups,
    stale: isQueryStale,
    categoryId: masterProduct?.primaryCategoryId,
    productMeasurements: masterProduct?.productMeasurements,
    productDivision: masterProduct?.productDivision,
    modelMeasurementText: variation.modelMeasurementText,
    desiredSize: desiredSize,
    sizeChartId: masterProduct?.sizeChartId,
    productInformation: { id: variation.id, name: variation.name },
    onChange: size => {
      if (pageviewEventHasFired) {
        event(AnalyticsEvents.GA4_CustomEvent, {
          event_name: AnalyticsEvents.CHOOSE_SIZE,
          event_params: {
            item_id_ep: variation.id,
            item_name_ep: variation.name,
            is_gift: 'false',
          },
        });
      }
      router.replace({ query: { ...router.query, size } }, '', {
        scroll: false,
      });
      setSizeHasChanged(true);
    },
    isModalSizeOpen: isModalSizeOpen,
  };

  if (!useStockInfoRedesign) {
    sizesProps = {
      ...sizesProps,
      inventory: inventory,
      addToCartReturnCode: addToCartReturnCode,
    };
  }

  return (
    <>
      <Sizes {...sizesProps} />
      <Separator gap="none" className="mt-4" />
    </>
  );
};
